export const multipleArraySort = (sortFunctions = []) => (a, b) => {

    for (let i=0; i < sortFunctions.length; i++) {
        const funcResult = sortFunctions[i](a, b);
        if (funcResult !== 0){
            return funcResult;
        }
    }    

}